import {
  breakpoints,
  SkeletonLoaderProps,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const FlexColumn = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  min-width: 0;
`;

export const TitleLabel = styled.div`
  width: 100%;
  text-align: left;
  max-width: 212px;
  ${typographyV2.bodySm};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-nort);

  @media ${breakpoints['max-lg']} {
    padding-right: 20px;
  }
`;

export const TickerLabel = styled.div`
  ${typographyV2.bodyXs};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  font-family: var(--font-nort);
  color: var(--text-soft);
`;

export const skeletonLoaderAreas: SkeletonLoaderProps['areas'] = [
  {
    styles: {
      width: '100%',
      height: '36px',
      borderRadius: '8px',
    },
  },
];
